<template>
  <div class="login-cont">
   <div class="logo">
     <img :src="logo" />
    </div>
    <div class="login-main">
        <div class="loginImg">
           <el-carousel indicator-position="outside" class="loginImg">
            <el-carousel-item v-for="(item,index) in list" :key="index">
                <img :src="item.src"/>
            </el-carousel-item>
          </el-carousel>
        </div>
        <el-form class="login-form" autoComplete="on" :model="loginForm" :rules="loginRules" ref="loginForm" label-position="left" @submit.native.prevent>
          <div class="login-con">
            <h1 class="login-h1">
              <p><img src='../../assets/image/logo_top_left.png'/></p>
              <!-- <span></span> -->
            </h1>
            <el-form-item prop="username" >
              <span class="login_icon">
              </span>
              <el-input name="username" type="tel" v-model="loginForm.username" autoComplete="off" placeholder="用户名" :maxlength='maxlengthValue' prefix-icon="" />
            </el-form-item>
            <el-form-item prop="password">
              <span class="login_icon password_l">
              </span>
              <el-input name="password" :type="passwordType"  @keyup.enter.native="handleLogin" v-model="loginForm.password" autoComplete="off" placeholder="密码" />
              <span class="eye-icon" @click="showPwd">
                  <i v-if='pswFlag' class="iconfont icon-icon_yulan"></i>
                  <svg-icon v-else  icon-class="eye" />
              </span>
            </el-form-item>
            <el-row type="flex" class="row-bg" justify="start">
                <div class="rember-me">
                  <el-checkbox v-model="checked">记住我</el-checkbox>
                </div>
            </el-row>
            <el-button type="primary" native-type="submit"  :loading="loading" @click="handleLogin" style="background-color: #2b8ade!important;border-color: #2b8ade!important" >{{$t('login.logIn')}}</el-button>
          </div>
        </el-form>
    </div>
    <div class="footer-warp">
        <div class="footer-main">
            <div class="footer-list">
              <span>
                推荐浏览器：<img src='../../assets/image/browser1.jpg'/>
              </span>
              <span class="text-right">
                赢销通服务热线：400-687-0099
              </span>
            </div>
            <p>北京赢销通软件技术有限公司 © 版权所有</p>
        </div>
    </div>
  </div>
</template>

<script>
// import { isvalidUsername } from '@/utils/validate'
import LangSelect from '@/components/LangSelect'
import SocialSign from './socialsignin'
import { Message } from 'element-ui'
import Cookies from 'js-cookie'
import { mapGetters } from 'vuex'
let nameValidate
try {
  nameValidate = require('@/_app/' + process.env.PROJECT + '/src/config/validate.js').loginName
  console.log(require('@/_app/' + process.env.PROJECT + '/src/config/validate.js'))
} catch (e) {
  console.warn('没有配置个性化的验证账号方法')
}
let interval = null
export default {
  computed: {
    ...mapGetters({
      login: 'login'
    }),
    // ...mapGetters({
    //   haspwd: 'haspwd'
    // }),
    ...mapGetters({
      config: 'config'
    }),
    containerStyle() {
      if (this.login && this.login['login-background']) {
        return {
          'background-image': 'url(' + this.login['login-background'] + ')'
        }
      } else {
        return {}
      }
    },
    logo() {
      if (this.login) {
        return this.login['login-logo'] || ''
      } else {
        return ''
      }
    },
    loginTitleImg() {
      if (this.login) {
        return this.login['login-title'] || ''
      } else {
        return ''
      }
    },
    loginTitle() {
      if (this.config) {
        return this.config.titleZh || this.config.title
      } else {
        return ''
      }
    }
  },
  components: { LangSelect, SocialSign },
  name: 'login',
  data() {
    const username = []
    if (nameValidate) {
      username.push({ required: true, trigger: 'blur', validator: nameValidate })
    }
    // const validateUsername = (rule, value, callback) => {
    //   if (!isvalidUsername(value)) {
    //     callback(new Error('Please enter the correct user name'))
    //   } else {
    //     callback()
    //   }
    // }
    // const validatePassword = (rule, value, callback) => {
    //   if (value.length < 6) {
    //     callback(new Error('The password can not be less than 6 digits'))
    //   } else {
    //     callback()
    //   }
    // }
    const name = Cookies.get('login-username') || ''
    const checked = !!name
    return {
      checked: checked,
      loginForm: {
        username: name,
        password: ''
      },
      pwdForm: {
        tel: '',
        telcode: '',
        fpwdret: '',
        fpwd: ''
      },
      loginRules: {
        username: username
        // password: [{ required: true, trigger: 'blur', validator: validatePassword }]
      },
      maxlengthValue: '',
      passwordType: 'password',
      loading: false,
      pwdLoading: false,
      index: 1,
      showDialog: false,
      time: 60, // 发送验证码倒计时
      sendMsgDisabled: false,
      sendText: '获取验证码',
      pswFlag: false,
      list: [
        {
          src: require('../../assets/image/banner_login_1.png')
        },
        {
          src: require('../../assets/image/banner_login_2.png')
        },
        {
          src: require('../../assets/image/banner_login_3.png')
        },
        {
          src: require('../../assets/image/banner_login_4.png')
        }
      ]
    }
  },
  methods: {
    showPwd() {
      if (this.passwordType === 'password') {
        this.pswFlag = true
        this.passwordType = ''
      } else {
        this.passwordType = 'password'
        this.pswFlag = false
      }
    },
    backLogin(val) {
      var error = document.getElementsByClassName('el-form-item__error')[0] ? document.getElementsByClassName('el-form-item__error')[0] : ''
      if (val === 2) {
        error ? error.style.display = 'none' : ''
      } else {
        error ? error.style.display = '' : ''
      }

      this.passwordType = 'password'
      this.time = 60
      clearInterval(interval)
      if (!this.checked) {
        this.loginForm.username = ''
      }
      this.loginForm.password = ''
      this.pwdForm.tel = ''
      this.pwdForm.telcode = ''
      this.pwdForm.fpwdret = ''
      this.pwdForm.fpwd = ''
      this.sendMsgDisabled = false
      if (val === 1) {
        this.index = 1
      } else {
        this.index = 2
      }
    },
    handleLogin() {
      localStorage.clear()
      const uPattern = /.{4,20}$/
      // this.$refs.loginForm.validate(valid => {
      //   if (valid) {
      //     this.loading = true
      //     this.$store.dispatch('LoginByUsername', this.loginForm).then(() => {
      //       this.loading = false
      //       this.$router.push({ path: '/' })
      //     }).catch(() => {
      //       this.loading = false
      //     })
      //   } else {
      //     console.log('error submit!!')
      //     return false
      //   }
      // })
      if (!this.loginForm.username) {
        this.$message({
          message: '请输入账号',
          type: 'warning'
        })
        return false
      } else if (!uPattern.test(this.loginForm.username) || this.loginForm.username.length > 20 || this.loginForm.username < 4) {
        if (this.loginForm.username !== 'admin') {
          this.$message({
            message: '账号长度在 4 到 20 个字符',
            type: 'warning'
          })
          return false
        }
      }
      if (!this.loginForm.password) {
        this.$message({
          message: '请输入密码',
          type: 'warning'
        })
        return false
      }
      this.loading = true
      this.$store.dispatch('LoginByUsername', this.loginForm).then((res) => {
        if (this.checked) {
          Cookies.set('login-username', this.loginForm.username, { path: window.location.pathname })
        } else {
          Cookies.remove('login-username', { path: window.location.pathname })
        }
        this.loading = false
        if (res.code === 0) {
          this.$router.push({ path: '/' })
        } else {
          this.$message.error(res.message)
        }
      }).catch((error) => {
        this.$message.error(error.message)
        this.loading = false
      })
    },
    afterQRScan() {
      // const hash = window.location.hash.slice(1)
      // const hashObj = getQueryObject(hash)
      // const originUrl = window.location.origin
      // history.replaceState({}, '', originUrl)
      // const codeMap = {
      //   wechat: 'code',
      //   tencent: 'code'
      // }
      // const codeName = hashObj[codeMap[this.auth_type]]
      // if (!codeName) {
      //   alert('第三方登录失败')
      // } else {
      //   this.$store.dispatch('LoginByThirdparty', codeName).then(() => {
      //     this.$router.push({ path: '/' })
      //   })
      // }
    },
    getTelCode() { // 获取短信验证码
      if (!this.pwdForm.tel) {
        this.$message({
          message: '请输入用手机号',
          type: 'warning'
        })
        return false
      }
      this.$store.dispatch('sendMobileMsg', this.pwdForm.tel).then((res) => {
        if (res.code === 0) {
          this.send()
          this.sendMsgDisabled = true
        } else {
          Message({
            message: res.message,
            type: 'warning',
            duration: 2 * 1000
          })
        }
      }).catch(() => {
        this.loading = false
      })
    },
    handlePwd() { // 找回密码
      if (!this.pwdForm.tel) {
        this.$message({
          message: '请输入用手机号',
          type: 'warning'
        })
        return false
      }
      if (!this.pwdForm.telcode) {
        this.$message({
          message: '请输入短信验证码',
          type: 'warning'
        })
        return false
      }
      if (!this.pwdForm.fpwd) {
        this.$message({
          message: '请输入密码',
          type: 'warning'
        })
        return false
      }
      if (!this.pwdForm.fpwdret) {
        this.$message({
          message: '请确认密码',
          type: 'warning'
        })
        return false
      }
      this.pwdLoading = true
      this.$store.dispatch('getRetrievePassword', this.pwdForm).then((res) => {
        this.pwdLoading = false
        if (res.code === 0) {
          Message({
            type: 'success',
            message: this.$t('lang.restPass_success')
          })
          this.pwdForm.tel = ''
          this.pwdForm.telcode = ''
          this.pwdForm.fpwdret = ''
          this.pwdForm.fpwd = ''
          this.index = 1
          // this.$router.push({ path: '/' })
        } else {
          Message({
            message: res.message,
            type: 'warning',
            duration: 2 * 1000
          })
        }
      }).catch(() => {
        this.pwdLoading = false
      })
    },
    send() { // 倒计时
      const me = this
      me.sendMsgDisabled = true
      interval = setInterval(function() {
        if ((me.time--) <= 0) {
          me.time = 60
          me.sendMsgDisabled = false
          clearInterval(interval)
        }
      }, 1000)
    }
  },
  created() {
    // if (this.login.haspwd) {
    //   this.maxlengthValue = 20
    // }
    // window.addEventListener('hashchange', this.afterQRScan)
  },
  destroyed() {
    // window.removeEventListener('hashchange', this.afterQRScan)
  }
}
</script>
<style rel="stylesheet/scss" lang="scss" scoped>
.login-cont {
  position: fixed;
  height: 100%;
  width: 100%;
  min-width:1200px;
  display:flex;
  background-image: url('../../assets/image/bg_login.jpg');
  background-repeat: no-repeat;
  background-size: 100% 100%;
  .login-main{
    display:flex;
    width: 900px;
    height: 600px;
    position: absolute;
    top: 50%;
    left: 50%;
    margin-left: -450px;
    margin-top: -375px;
    border-radius:10px;
    overflow:hidden;
    font-size: 0;
    .loginImg {
      display: inline-block;
      width: 400px;
      height: 600px;
      overflow:hidden;
      img {
        width: 100%;
        height: 100%;
      }
    }
  }
  .logo{
    width:205px;
    height:133px;
    padding:50px 0 0 55px;
  }
  .login-form{
    // display:flex;
    // position:relative;
    // height:335px;
    // top:50%;
    // margin-top:-160px;
    display: inline-block;
    vertical-align: top;
    background-color: #fff;
    height: 600px;
    width: 500px;
    padding: 0 39px;
    border-radius:0 10px 10px 0;
  }
  .login-con{
    // width:400px;
    // margin-left:120px;
    // margin-right:80px;
  }
  .login-h1{
    width: 100%;
    position:relative;
    text-align:center;
    font-size:28px;
    color:#1e1e1e;
    padding-bottom:60px;
    p{
      padding-top:60px;
    }
    img{
      display:inline-block;
      max-width:320px;
      width:100%;
    }
  }
  .el-form-item {
    border:0;
    background: rgba(0, 0, 0, 0);
    border-radius: 0px;
    color: #454545;
  }
  .el-input {
    display: inline-block;
    width:100%;
    border-bottom:1px solid #f2f2f2!important;
    input.el-input__inner {
      background: transparent;
      border: 0px;
      -webkit-appearance: none;
      border-radius: 0px;
      line-height:24px;
      height: 47px;
      padding: 12px 5px 12px 15px;
      color:#333;
      font-size:18px!important;
      &:-webkit-autofill {
        -webkit-box-shadow: 0 0 0px 1000px #fff inset !important;
        -webkit-text-fill-color: #333 !important;
      }
    }
  }
  .row-bg{
    padding-top:20px;
    padding-bottom: 96px;
  }
  .login_icon{
    position:absolute;
    left:5px;
    top:2px;
    bottom:0px;
    width:30px;
    height:20px;
    z-index: 8;
    background:url('../../assets/image/login_icon.jpg') no-repeat;
  }
  .login_icon.password_l{
    background-position:0 -54px;
  }
}
//底部
.footer-warp {
  position: fixed;
  left: 0px;
  bottom: 0;
  right: 0;
  min-height:80px;
  background: #fff;
  .footer-main {
    width:900px;
    margin: 0 auto;
    padding:10px 0 0;
    .footer-list{
      display:flex;
      padding:20px 0 30px;
      color: #717171;
      span{
        flex:1;
        font-size:16px;
        height:65px;
        line-height:65px;
        align-items: center;
        display:flex;
      }
      span.text-right{
        display:block;
        text-align: right
      }
    }
    p {
      color: #999;
      font-size:12px;
      line-height: 24px;
      text-align: center;
      padding: 0;
    }

  }
}
//适配
// <=1440的设备
@media screen and  (max-width: 1440px){
  .login-cont{
    .logo{
      padding-top:30px;
    }
    .login-main{
      width:760px;
      height:440px;
      margin-top:-273px;
      margin-left:-400px;
      .loginImg{
        width:330px;
        height:440px;
      }
      .login-form{
        width:430px;
        height:440px;
      }
      .login-h1{
        padding-bottom:40px;
        p{
          padding-top:30px;
          img{
            width:90%;
          }
        }
      }
      .row-bg{
        padding-bottom:40px;
      }
    }
  }
  .footer-warp{
    .footer-main {
      width:760px;
      .footer-list{
        padding-top:0px;
        padding-bottom:0px;
      }
    }
  }

}
// <=1200的设备
@media screen and (max-width:1200px){
    .login-cont{
      .logo{
        padding-top:30px;
        img{
          width:90%;
        }
      }
      .login-main{
        width:600px;
        height:420px;
        margin-top:-250px;
        margin-left:-300px;
        .loginImg{
          width:260px;
          height:420px;
        }
        .login-form{
          width:340px;
          height:420px;
          padding:0 30px;
        }
        .login-h1{
          padding-bottom:20px;
        }
        .row-bg{
          padding-bottom:40px;
        }
      }
  }
  .footer-warp{
    .footer-main {
      width:700px;
      .footer-list{
        padding-top:0px;
        padding-bottom:0px;
      }
    }
  }
}
</style>
<style>
input:-webkit-autofill { box-shadow: 0 0 0px 1000px white inset !important;}
.login-cont .el-input--medium .el-input__inner{
  border: 1px solid #fff!important;
  font-size:16px!important;
  padding:0 15px 0 36px;
}
#app .login-form .el-button--primary{
    background-color: #b09367 !important;
    border-color: #b09367 !important;
    border-radius:0px!important;
    height:50px;
    width:100%!important;
    font-size:20px;
  }
#app .login-form .el-button--primary:hover{
  background-color: #dbab6d !important;
  border-color: #dbab6d !important;
}
#app .login-form .el-input.is-active .el-input__inner, #app .login-form .el-input__inner:focus {
    border: 1px solid #fff!important;
    outline: 0!important;
}
.login-form .el-form-item__content{
  color:#666;
  font-size:18px;
  width:auto;
}
.el-carousel__container{
  width:100%;
  height:100%;
}
.el-carousel__indicators--outside{
  position:absolute;
  left: 30%;
  bottom:10px;
}
.el-carousel__indicators--outside button{
  background-color:#fff;
}
.el-carousel__arrow{
  display:none;
}
</style>



// WEBPACK FOOTER //
// src/_app/wwka/src/views/login/index.vue